<div class="kz-kaza--options"
     *ngIf="!isFavoriteGallery && medias.length>0 && requestDoneOnce">
  <app-flux-options-order
    [order]="requestOrder"
    (orderChanged)="requestOrder=$event"
    [disabled]="mediasLoading"
  ></app-flux-options-order>
</div>

<div class="kz-gallery-photos"
     [ngClass]="imgContainerSize"
     *ngIf="medias.length">
  <div class="kz-kaza-gallery-container">
    <div class="kz-gallery"
         infinite-scroll
         [infiniteScrollDistance]="50"
         [infiniteScrollThrottle]="10"
         (scrolled)="onScroll()"
    >
      <div
        class="kz-gallery--item ratio"
        [ngClass]="setRatioClass(media['width'], media['height'])"
        *ngFor="let media of medias; let i = index; trackBy: trackMedia;">
        <div
          [class.img-loading]="imgLoading[i]"
          (click)="showDiapo(i)"
          [style.background-image]="'url(' + media.thumbs[imgSize] + ')' | safeUrl: 'style'"
          appOnBgImgLoad
          (imageLoaded)="imageLoaded(i)">
          <i class="kz-waiting-img" *ngIf="preloadThumbs"
             [style.background-image]="'url(' + media.thumbs[preloadSize] + ')' | safeUrl: 'style'"></i>
        </div>
        <app-favorite-button
          class="kz-gallery--favorite-button" *ngIf="isFavoriteGallery"
          [media]="media" (removed)="removeMedia(media['@id'])" [bordered]="true"></app-favorite-button>
      </div>
    </div>
  </div>

  <div *ngIf="medias && medias.length===0 && requestDoneOnce && !mediasLoading"
       class="kz-grid--empty">
    <ng-content></ng-content>
  </div>

  <app-back-to-top></app-back-to-top>
</div>
<div class="center" *ngIf="mediasLoading">
  <kz-loader size="small"></kz-loader>
</div>

<app-empty-result
  *ngIf="medias && medias.length===0 && requestDoneOnce && !mediasLoading"
  class="kz-kaza-gallery--empty"
  >
  <ng-container i18n="@@imgGallery.nomedia">No media</ng-container>

</app-empty-result>

<div class="kz-kaza-diaporama-modal"
     *ngIf="medias && medias.length && diapoActive>=0"
     [@modalEntranceAnimation]="{value: (diapoActive>=0)}">
  <!--(click)="diapoActive=-1"-->
  <div class="kz-kaza-diaporama-overlay" ></div>
  <div class="kz-kaza-diaporama-modal-container" *ngIf="diapoActive>=0">
    <button class="kz-kaza-diaporama-modal-close" (click)="diapoActive=-1">
      <kz-icons name="cross"></kz-icons>
    </button>
    <app-img-diaporama
      class="child-animate"
      [medias]="medias"
      [totalSlides]="totalSlides"
      [activeSlide]="diapoActive"
      (closeDiapo)="diapoActive=-1"
      (updateMediaList)="updateMediasList()"
      (removedFavorite)="removeMedia($event)"
      ></app-img-diaporama>
    <!--
    (clickOutside)="diapoActive=-1"
    -->
  </div>
</div>



